module.exports = __webpack_public_path__ + "img/mobile_stopped.b8fb6710.svg";